import { useCallback } from 'react';
import { useLocation } from 'react-router';
// Need to import to real one to override the one from react-router-dom
// eslint-disable-next-line no-restricted-imports
import { NavigateFunction, NavigateOptions, To, useNavigate } from 'react-router-dom';

import { navigateAction } from '../thunks/navigateAction';
import { useAppDispatch } from './useSelectors';

/**
 * A hook that wraps react-router-dom's `useNavigate` hook and adds the ability to navigate to a hash.
 *
 * The normal `useNavigate` hook does not preserve the query string when navigating to a hast. This hook
 * will preserve the query string when navigating to a hash.
 */
export const useAppNavigate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(
    (to: To, _?: NavigateOptions) => {
      if (typeof to === 'string' && to.startsWith('#')) {
        navigate({
          search: location.search,
          hash: to,
        });
      } else {
        dispatch(
          navigateAction({
            to,
            navigate,
          })
        );
      }
    },
    [dispatch, location.search, navigate]
  ) as NavigateFunction;
};

export type Navigate = ReturnType<typeof useAppNavigate>;
